module.exports = {
      id: "sort-usage",
      viewBox: "0 0 6 8",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#sort",
      toString: function () {
        return this.url;
      }
    }